import { Route } from "react-router"
import { ForesterDashboard } from "./pages/ForesterDashboard"
import { SaleDetail } from "./pages/SaleDetail"
import { SaleCreate } from "./pages/SaleCreate"
import { SaleEdit } from "./pages/SaleEdit"
import { BidCreate } from "./pages/BidCreate"
import { BidList } from "./pages/BidList"
import BirddogSignup from "./pages/BirddogSignup"
import BirddogLogin from "./pages/BirddogLogin"
import { BirddogProtectedRoute } from "./components/BirddogProtectedRoute"
import { ForesterProtectedRoute } from "./components/ForesterProtectedRoute"
import { TimberBuyerProtectedRoute } from "./components/TimberBuyerProtectedRoute"

// Export route definitions as an array of JSX elements
export const birddogRoutes = [
  // Unprotected routes (login/signup)
  <Route
    key="birddog-signup"
    path="/birddog/signup"
    element={<BirddogSignup />}
  />,
  <Route
    key="birddog-login"
    path="/birddog/login"
    element={<BirddogLogin />}
  />,

  // Protected routes (require BirdDog authentication)
  <Route key="birddog-protected" element={<BirddogProtectedRoute />}>
    <Route key="birddog-home" path="/birddog" element={<ForesterDashboard />} />
    <Route
      key="birddog-dashboard"
      path="/birddog/dashboard"
      element={<ForesterDashboard />}
    />
    <Route
      key="birddog-sale-detail"
      path="/birddog/sale/:saleId"
      element={<SaleDetail />}
    />
    <Route
      key="birddog-bid-list"
      path="/birddog/sale/:saleId/bids"
      element={<BidList />}
    />

    {/* Forester-only routes */}
    <Route key="forester-protected" element={<ForesterProtectedRoute />}>
      <Route
        key="birddog-sale-create"
        path="/birddog/sale/create"
        element={<SaleCreate />}
      />
      <Route
        key="birddog-sale-edit"
        path="/birddog/sale/:saleId/edit"
        element={<SaleEdit />}
      />
    </Route>

    {/* Timber Buyer-only routes */}
    <Route key="timber-buyer-protected" element={<TimberBuyerProtectedRoute />}>
      <Route
        key="birddog-bid-create"
        path="/birddog/sale/:saleId/bid"
        element={<BidCreate />}
      />
    </Route>
  </Route>,
  // Add more birddog routes here as needed
]
